import { createContext } from 'react';
import { AudioRecorder } from '../util/audio-recorder';

export const AudioRecorderContext = createContext<{recorder?: AudioRecorder}>({});